/**
 * أنواع تصوير مُخفاة عن خطوة «نوع التصوير» في الحجز والفلاتر واختيار التخصصات.
 * تُبقى التسميات في bookingLabels وملفات العرض للحجوزات القديمة فقط.
 */
export const HIDDEN_BOOKING_PHOTOGRAPHY_TYPES = new Set(['commercial', 'fashion', 'sports']);

/** قيم تخصصات الملف الشخصي / التسجيل (corporate = التصوير التجاري في النماذج القديمة) */
export const HIDDEN_PROFILE_SPECIALIZATION_VALUES = new Set(['corporate', 'sports']);

/** تسميات عربية لا تُعرض في بطاقات الاستكشاف وما شابه */
export const HIDDEN_SPECIALIZATION_LABELS_AR = new Set([
  'التصوير التجاري',
  'تصوير الأزياء',
  'التصوير الرياضي',
]);

export function filterVisibleBookingTypes(types) {
  if (!Array.isArray(types)) return [];
  return types.filter((t) => t?.value && !HIDDEN_BOOKING_PHOTOGRAPHY_TYPES.has(t.value));
}

/** أنواع «نوع التصوير» المسموحة لكل فئة (خطوة فئة التصوير: commercial | individual) */
export const PHOTOGRAPHY_TYPES_BY_BOOKING_CATEGORY = {
  commercial: ['real-estate', 'food', 'product', 'event'],
  individual: ['portrait', 'wedding'],
};

export function getAllowedPhotographyTypeValuesForCategory(category) {
  if (category === 'commercial' || category === 'individual') {
    return new Set(PHOTOGRAPHY_TYPES_BY_BOOKING_CATEGORY[category]);
  }
  return null;
}

/** تحقق صلاحية نوع التصوير مع الفئة (بدون فئة = قبول أي نوع مرئي — مسودات قديمة) */
export function isPhotographyTypeAllowedForCategory(typeValue, category) {
  if (!typeValue) return false;
  const allowed = getAllowedPhotographyTypeValuesForCategory(category);
  if (!allowed) return true;
  return allowed.has(typeValue);
}
